import React from "react";
import BarcodeScanner from "../../components/barcode-scanner";

export default function() {
  const { watching } = this.state;
  return (
    <BarcodeScanner
      watching={watching}
      onDetect={code => this._scanBarcode(code)}
    />
    // <div>
    //   {JSON.stringify(navigator.mediaDevices.getSupportedConstraints())}
    // </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/scanner-screen/view.js